import { useContext } from "react";
import { SettingsContext } from "../../contexts";

export function useLang() {
  const { allLocaleSlugs } = useContext(SettingsContext);
  return allLocaleSlugs;
}
